import React from "react";
import { TbArrowBigRight } from "react-icons/tb";
import { userContext } from '../../../context/usercontext';
import { useContext } from 'react';
import { toast } from "react-hot-toast";

const Steps = ({ step }) => {
  const {setRequestStep} = useContext(userContext)
  const nextStep = (s)=>{
     toast('لطفا از دکمه "بعدی" و "قبلی" برای جا به جایی بین مراحل استفاده کنید')
  }

  return (
    <div className="d-flex align-items-center justify-content-around ">
      <button onClick={()=>{nextStep(4)}} type="submit" className={`w-25 ${step === 4 ? "request-step-button-activ" :"request-step-button"}`}> فاکتور و پرداخت</button>
      <span className="d-none d-md-block">
        <TbArrowBigRight />
      </span>
      <button onClick={()=>{nextStep(3)}} type="submit" className={` w-25 ${step === 3 ? "request-step-button-activ" :"request-step-button"}`}> اطلاعات کارشناس</button>
      <span className="d-none d-md-block">
        <TbArrowBigRight />
      </span>
      <button onClick={()=>{nextStep(2)}} type="submit" className={` w-25 ${step === 2 ? "request-step-button-activ" :"request-step-button"}`}> اطلاعات مالک</button>
      <span className="d-none d-md-block">
        <TbArrowBigRight />
      </span>

      <button onClick={()=>{nextStep(1)}} type="submit" className={`w-25 ${step === 1 ? "request-step-button-activ" :"request-step-button"}`}> اطلاعات ملک</button>
    </div>
  );
};

export default Steps;
